import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Pool/Analisis`, method: 'GET', body: null})
}
